import { render, staticRenderFns } from "./BookingItemsTable.vue?vue&type=template&id=c5b9deac&scoped=true"
import script from "./BookingItemsTable.vue?vue&type=script&lang=js"
export * from "./BookingItemsTable.vue?vue&type=script&lang=js"
import style0 from "./BookingItemsTable.vue?vue&type=style&index=0&id=c5b9deac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b9deac",
  null
  
)

export default component.exports